export type RouteLanguage = 'en' | 'es' | 'pt';

const LANG_PATTERN = /^\/(en|es|pt)(?=\/|$)/;
const BLOG_PATTERN = /^\/(en|es|pt)\/blog(?:\/|$)/;

export const getLangFromPath = (pathname: string): RouteLanguage => {
  const match = pathname.match(LANG_PATTERN);
  return (match?.[1] as RouteLanguage | undefined) ?? 'en';
};

export const replaceLangInPath = (pathname: string, newLang: RouteLanguage): string => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;

  if (LANG_PATTERN.test(normalizedPath)) {
    return normalizedPath.replace(LANG_PATTERN, `/${newLang}`);
  }

  if (normalizedPath === '/') {
    return `/${newLang}`;
  }

  return `/${newLang}${normalizedPath}`;
};

export const isLocalizedBlogPath = (pathname: string): boolean => {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return BLOG_PATTERN.test(normalizedPath);
};
